import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";
import "jspdf-autotable";
import ImageUploader from "react-images-upload";
import { getSizeCall, deleteSize, updateSize } from "./size.action";

const ViewSize = (props) => {
  useEffect(() => {
    props.getSizeCall();
  }, []);

  return (
    <>
      {props.isFetchingGetSize ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <MaterialTable
              title="Size Details"
              columns={[
                {
                  title: "Size",
                  field: "sizeName",
                  render: (rowData) => rowData.sizeName,
                },
                { title: "Size Description", field: "sizeDescription" },
              ]}
              data={props.sizeInfo}
              options={{
                actionsColumnIndex: -1,
                filtering: true,
                exportButton: true,
                exportAllData: true,
                headerStyle: {
                  position: "sticky",
                  top: 0,
                  color: "#00BBBB",
                  fontWeight: "550",
                  onRowAdd: "none",
                },
              }}
              editable={{
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      props.updateSize(newData, oldData);
                    }, 600);
                  }),

                onRowDelete: (oldData) =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      props.deleteSize(oldData.sizeId);
                    }, 600);
                  }),
              }}
            />
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSizeCall: () => dispatch(getSizeCall()),
    deleteSize: (sizeId) => dispatch(deleteSize(sizeId)),
    updateSize: (newData, oldData) => dispatch(updateSize(newData, oldData)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingGetSize: state.sizeReducer.isFetchingGetSize,
  sizeInfo: state.sizeReducer.sizeInfo,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewSize);
